import classNames from "classnames";
import { useSiteFeatures } from "../../hooks/useSiteFeatures";
import GridCell, { GridCellCommonProps } from "./GridCell";
import "./style.scss";
import { Link } from "react-router-dom";
import ImageOrVideo from "../ImageOrVideo";
import { unwrapAsset } from "../../utils/CockpitUtils";
import { Asset } from "../../types/Asset";
import { PropsWithChildren } from "react";

const ImageCell = ({
  id,
  className,
  cellSize = "1x1",
  image,
  bkgColor,
  textBkgColor,
  heading = "",
  text = "",
  label = "",
  imageAltText = "",
  url,
  theme = "black",
  requiresFeature,
  children = <></>,
  ...unhandledProps
}: PropsWithChildren<GridCellCommonProps> & {
  image?: Asset | null;
  bkgColor?: string;
  textBkgColor?: string;
  heading?: string;
  text?: string;
  label?: string;
  url?: string;
  imageAltText?: string;
}) => {
  const features = useSiteFeatures();
  const hasContent = heading || text;
  console.log("image cell", unwrapAsset(image));
  // if (bkgColor === undefined) bkgColor = hasContent ? "#000" : "#fff";

  const WrapInLink = ({
    url,
    children
  }: PropsWithChildren<{
    url?: string | null;
  }>) => {
    return url ? <Link to={url}>{children}</Link> : <>{children}</>;
  };

  return !requiresFeature || features.hasFeature(requiresFeature) ? (
    <GridCell
      id={id}
      className={classNames(
        "image-cell",
        { "has-content": hasContent },
        className
      )}
      cellSize={cellSize}
      theme={theme}
      bkgColor={bkgColor}
      requiresFeature={requiresFeature}
      {...unhandledProps}
    >
      <WrapInLink url={url}>
        <>
          <ImageOrVideo
            image={unwrapAsset(image)}
            className="bkg"
            centerImage
            altText={imageAltText}
          />
          <div className="content">
            <div
              className={classNames({ hasHeading: !!heading })}
              style={
                heading
                  ? {
                      background: textBkgColor
                        ? textBkgColor
                        : "rgba(0,0,0,0.3)"
                    }
                  : {}
              }
            >
              {label && <div className="label">{label}</div>}
              <h4>{heading}</h4>
              <p>{text}</p>
              {children}
            </div>
          </div>
        </>
      </WrapInLink>
    </GridCell>
  ) : null;
};

export default ImageCell;
